export const ModelType = {
  0: '全部',
  1: '三维家',
  2: '建E',
  3: '欧模',
} as const;

export const MaterialType = {
  1: '模型',
  2: '材质',
  3: '定制',
};

export const HotKeyType = {
  0: '综合',
  1: '最新',
  2: '最热',
  3: '周热度',
  4: '月热度',
};
export const quickNames = {
  '/brand': '品牌馆',
  '/circle': '圈子',
  '/my-model': '我的模型',
  '/favorites': '收藏夹',
  '/recently': '最近使用',
  '/latest-model': '最新模型',
  '/model-theme': '模型专题',
};

// 定义请求参数类型
export interface MaterialListParams {
  current: number;
  size?: number; // 假设你有 size 参数
  isPrefetch?: boolean;
  [key: string]: any; // 其他可选参数
}
// 定义返回数据类型
export interface MaterialItem {
  id: string;
  img: string;
  categoryname: string;
  designMaterialImagePaths: string[];
  type: string;
  dragId: string;
  designType: string;
  // 其他属性...
}
export interface MaterialListResponse {
  total: number;
  data: MaterialItem[];
}
